<template>
  <span
    :class="{
      [disciplineName]: chip,
      'chip white--text  px-2 mr-2': chip,
      'chip-smaller': chip && !large,
      'large-chip': chip && large,
      'secondary--text': !chip
    }"
  >
    {{ text }}
  </span>
</template>
<script>
import gql from "fraql";
import { useDisciplineHelper } from "@composables/masterdata/competitions/disciplines";
export default {
  name: "AppShowDisciplineName",
  props: {
    name: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    chip: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      ...useDisciplineHelper()
    };
  },
  computed: {
    disciplineName() {
      if (this.id) return this.getDisciplineFromMaster(this.id, "codename");
      else return this.name;
    },
    text() {
      return this.$t(
        "common:discipline." + this.disciplineName,
        this.disciplineName
      );
    }
  },
  fragments: {
    eventDiscipline: gql`
      fragment _ on Event {
        disciplineId
        discipline @client {
          id
          name
          codename
        }
      }
    `,
    discipline: gql`
      fragment _ on Discipline {
        id
        name
        codename
      }
    `
  }
};
</script>
<style scoped>
span {
  text-transform: capitalize;
}
.large-chip {
  height: 20px !important;
}
</style>
